import React from 'react';
import { render } from 'react-dom'
import { Provider } from "react-redux";
import store from "store";
import 'assets/styles/css/index.css';

import BuildingPage from 'Layout/BuildingPage';

render(
    <Provider store={store}>
        <BuildingPage/>
    </Provider>,
    document.getElementById('root')
);